// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.ibanSelector.';

const CANCEL = `${DOMAIN}cancel`,
  CONTINUE = `${DOMAIN}continue`,
  ERROR_MESSAGE = `${DOMAIN}errorMessage`,
  LABEL = `${DOMAIN}label`,
  PLACEHOLDER = `${DOMAIN}placeholder`;

export { CANCEL, CONTINUE, ERROR_MESSAGE, LABEL, PLACEHOLDER };
